import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';
import { fi } from 'date-fns/locale';

/** Robust toDate — handles Date, ISO string, or null. */
export function toDate(x: Date | string | null | undefined): Date | null {
  if (!x) return null;
  if (x instanceof Date) return x;
  const d = parseISO(x);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Finnish short form: pp.kk.vvvv */
export function formatDateShort(x: Date | string | null | undefined): string {
  const d = toDate(x);
  if (!d) return '—';
  return format(d, 'd.M.yyyy', { locale: fi });
}

/** Finnish date+time: pp.kk.vvvv hh:mm */
export function formatDateTime(x: Date | string | null | undefined): string {
  const d = toDate(x);
  if (!d) return '—';
  return format(d, 'd.M.yyyy HH:mm', { locale: fi });
}

/** "2 päivää sitten" — relative for timeline / age columns. */
export function formatRelative(x: Date | string | null | undefined): string {
  const d = toDate(x);
  if (!d) return '—';
  return formatDistanceToNowStrict(d, { addSuffix: true, locale: fi });
}

/** Age in days from `createdAt` to now (rounded down). */
export function daysOld(x: Date | string | null | undefined, now: Date = new Date()): number {
  const d = toDate(x);
  if (!d) return 0;
  return Math.floor((now.getTime() - d.getTime()) / (24 * 3600_000));
}
